import './App.css';
import { Toaster } from "react-hot-toast";

function App() {
  return (
    <div className="App">
      <Toaster position='bottom-left' />
    </div>
  );
}

export default App;
